import { useTranslation } from 'react-i18next';

import './tax-statement.scss';

const TaxStatement = ({ label }: { label: string }): JSX.Element => {
    const { t } = useTranslation();

    return <p className="tax-statement">{t(label)}</p>;
};

export default TaxStatement;
